import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";
import "mapbox-gl/dist/mapbox-gl.css";
import "@core/styles/tokens.css";
import "@core/styles/app.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Selection lives in the URL, so QR codes and shared links deep-link
            straight in and the back button works without extra wiring. */}
        <Route path="/" element={<App />} />
        <Route path="/station/:stationId" element={<App />} />
        <Route path="/waterbody/:group" element={<App />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
